module.exports = __webpack_public_path__ + "static/media/projectManager.99b62e9e.png";